module.exports = __webpack_public_path__ + "img/level_six.d43f80dc.png";